/**
 * Program Service
 * Register Angular Services for Programs
 *
 * @package:  Betta
 * @version:  2.0
 * @author:   Cyrill N KALITA
 * @return Resource
 */

angular.module('flsServices').factory('Program', ['$resource', function($resource){
    return $resource('/api/v3/program/:id');
}]);
